
module Eseebase {
    export abstract class PositiveNegative {
        public static Positive = '+';
        public static Negative = '-';
    }
}